import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import PropertyCheckBox from '../../common/Fields/PropertyCheckBox';
import { getStateCodeOptions, generateUniqueKey } from 'helpers/utilities';
import AddManualProperty from './AddManualProperty';
import MlsSearchData from './MlsSearchData';
import ContentLoader from '../../common/loaders/ContentLoader';

class AddOpportunityProperty extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    show: PropTypes.bool.isRequired,
    hideModal: PropTypes.func,
    cancelAddProperty: PropTypes.func.isRequired,
    searchProperty: PropTypes.func.isRequired,
    saveProperty: PropTypes.func.isRequired,
    opportunityPayload: PropTypes.object.isRequired,
    size: PropTypes.number,
    mlsId: PropTypes.string,
    mlsState: PropTypes.string,
    savingProperty: PropTypes.bool.isRequired
  };

  state = {
    mlsId: this.props.mlsId,
    mlsState: this.props.mlsState,
    isWarning: false,
    displayMlsProperties: false,
    properties: null,
    errorCount: 0,
    selectId: 0,
    onClickMlsLookUpButton: false
  };

  onChangeMlsState = mlsState => {
    this.resetErrors();
    this.setState({ mlsState });
  };

  resetErrors = () => {
    this.setState({
      errorCount: 0,
      displayMlsProperties: false,
      properties: null,
      selectId: 0
    });
  };

  onChangeMlsId = mlsId => {
    this.resetErrors();
    this.setState({ mlsId, isWarning: false });
  };

  onClickMlsLookUp = async () => {
    const { mlsId, mlsState, errorCount } = this.state;
    this.resetErrors();
    if (mlsId) {
      this.setState({ onClickMlsLookUpButton: true });
      const propertyInformation = await this.props.searchProperty(
        mlsId,
        mlsState
      );
      this.setState({ onClickMlsLookUpButton: false });
      propertyInformation && propertyInformation.length
        ? this.setState({
          displayMlsProperties: true,
          properties: propertyInformation
        })
        : this.setState({ errorCount: errorCount + 1 });
    } else {
      this.setState({ isWarning: true });
    }
  };

  onClickCancel = () => {
    this.props.cancelAddProperty();
  };

  setSelect = id => {
    this.setState({ selectId: id });
  };

  SaveMLSProperty = async (savedProperty) => {
    const response = await this.props.saveProperty(
      this.props.opportunityPayload,
      savedProperty
    );
    if (response) {
      this.onClickCancel();
    }
  };

  render () {
    const { show, size = 10, title = ' ', hideModal, savingProperty } = this.props;
    const {
      isWarning,
      mlsId,
      displayMlsProperties,
      properties,
      errorCount,
      onClickMlsLookUpButton
    } = this.state;
    const isLoading = onClickMlsLookUpButton || savingProperty;

    return (
      <Modal
        show={show}
        onHide={hideModal}
        autoFocus
        size={size}
        dialogClassName='add-opportunity-property-container'
        backdropClassName='add-opportunity-property-backdrop'
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div>
            <span>Please select the state and enter the MLS ID #</span>
            <div className='propery-select-wrapper'>
              {isWarning && (
                <span className='mls-warning'>
                  <sup>*</sup>
                  {'MLS ID is required'}
                </span>
              )}
              <div className='mls-search-row'>
                <div>
                  <span>State</span>
                  <select
                    className='form-control propery-list-container'
                    value={this.state.mlsState}
                    onChange={event => this.onChangeMlsState(event.target.value)}
                  >
                    {getStateCodeOptions().map((option, index) => (
                      <option key={index} value={option.value}>
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <span className='mls-display'>MLS ID #</span>
                  <input
                    className='form-control'
                    value={this.state.mlsId}
                    onChange={event => this.onChangeMlsId(event.target.value)}
                  />
                </div>
                <div>
                  <button
                    className='form-control mls-lookup'
                    onClick={this.onClickMlsLookUp}
                  >
                    <span>Lookup</span>
                    <i className='material-icons material-icons-search' />
                  </button>
                </div>
              </div>
              {
                isLoading && <ContentLoader isLoading additionalClass={'content-loader-transparent'} />
              }
              {
                displayMlsProperties && properties.length > 0 &&
                <label><sup>*</sup> Please select a property from below </label>
              }
              {displayMlsProperties &&
              <div className='property-list'>
                {
                  (properties || []).map((property, index) => {
                    return (
                      <PropertyCheckBox
                        key={generateUniqueKey()}
                        check={index === this.state.selectId}
                        onChangeHandler={() => {
                          this.setSelect(index);
                        }}
                        additionalClassName={`opportunity-section-property ${
                          index === this.state.selectId ? 'selected' : ''
                        }`}
                      >
                        <MlsSearchData key={generateUniqueKey()} property={property.property} />
                      </PropertyCheckBox>
                    );
                  })}
              </div>
              }
              <React.Fragment>
                {errorCount === 1 && (
                  <div className='yellow-background'>
                    Sorry, the system was unable to locate MLS#{' '}
                    <strong>{mlsId}</strong>. Please re-confirm the number and
                    lookup again.
                  </div>
                )}
                {errorCount > 1 && (
                  <React.Fragment>
                    <div className='yellow-background'>
                      Sorry, the system was unable to locate MLS#{' '}
                      <strong>{mlsId}</strong>. Please fill in the fields below to add the property manually.
                    </div>
                    <AddManualProperty
                      onClickCancel={this.onClickCancel}
                      opportunityPayload={this.props.opportunityPayload}
                      saveManualMLSProperty={this.props.saveProperty}
                    />
                  </React.Fragment>
                )}
              </React.Fragment>
            </div>
          </div>
        </Modal.Body>
        {((properties && properties.length)) && (
          <Modal.Footer>
            <div className='white-background add-prop-wrapper'>
              <div className='add-prop-footer-button white-background'>
                <button
                  className='form-control'
                  onClick={() => this.onClickCancel()}
                >
                  Cancel
                </button>
              </div>
              <div className='add-prop-footer-button'>
                <button
                  className='form-control save-btn'
                  disabled={this.state.selectId == null}
                  onClick={() =>
                    this.SaveMLSProperty(properties[this.state.selectId])
                  }
                >
                  Save
                </button>
              </div>
            </div>
          </Modal.Footer>
        )}
      </Modal>
    );
  }
}

export default AddOpportunityProperty;
